var a = "__lodash_hash_undefined__";
function e(_) {
  return this.__data__.set(_, a), this;
}
var t = e;
export {
  t as default
};
//# sourceMappingURL=_setCacheAdd.js.map
